__turbopack_context__.v({
  "action": "TextItem-module-scss-module__4D_vkW__action",
  "card": "TextItem-module-scss-module__4D_vkW__card",
  "content": "TextItem-module-scss-module__4D_vkW__content",
  "textItem": "TextItem-module-scss-module__4D_vkW__textItem",
});
